import PropTypes from 'prop-types';
import { StringOrNumberType } from './index';

export const ReservationProgramType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired
});

export const ReservationOrderItemType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  quantity: PropTypes.number.isRequired,
  publicUserId: PropTypes.string,
  clientId: PropTypes.number,
  itemId: PropTypes.number.isRequired,
  picklistCategoryId: PropTypes.string.isRequired,
  picklistId: PropTypes.number.isRequired,
  reservationId: PropTypes.number.isRequired,
  reservationOrderId: PropTypes.number.isRequired,
  trackingMethodId: PropTypes.number.isRequired,
  itemSnapshot: PropTypes.shape({
    itemId: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired
  }),
  categorySnapshot: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired
  }),
  createdAt: PropTypes.string.isRequired,
  updatedAt: PropTypes.string
});

export const ReservationOrderType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  totalQuantity: PropTypes.number.isRequired,
  publicUserId: PropTypes.string,
  clientId: PropTypes.number,
  trackingMethodId: PropTypes.number.isRequired,
  picklistId: PropTypes.number.isRequired,
  picklistSnapshot: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired
  }),
  items: PropTypes.arrayOf(ReservationOrderItemType),
  notes: PropTypes.string,
  createdAt: PropTypes.string.isRequired,
  updatedAt: PropTypes.string
});

export const ReservationType = PropTypes.shape({
  id: PropTypes.number,
  outreachId: PropTypes.number,
  guestId: PropTypes.number,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  homeless: PropTypes.number,
  streetAddress: PropTypes.string,
  apartment: PropTypes.string,
  city: PropTypes.string,
  state: PropTypes.string,
  zipCode: PropTypes.string,
  email: PropTypes.string,
  homePhone: PropTypes.string,
  workPhone: PropTypes.string,
  cellPhone: PropTypes.string,
  householdTotal: PropTypes.number,
  requestTime: PropTypes.string,
  programs: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.number),
    PropTypes.arrayOf(ReservationProgramType)
  ]),
  status: PropTypes.number,
  note: PropTypes.string,
  orders: PropTypes.arrayOf(ReservationOrderType)
});

export const LimitRulesItemType = PropTypes.shape({
  key: PropTypes.string.isRequired,
  quantity: PropTypes.number.isRequired,
  from: PropTypes.number,
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
});

export const InventorySnapshotType = PropTypes.shape({
  item: PropTypes.shape({
    id: StringOrNumberType.isRequired,
    name: PropTypes.string.isRequired
  }),
  location: PropTypes.shape({
    id: StringOrNumberType.isRequired,
    name: PropTypes.string.isRequired
  }),
  zone: PropTypes.shape({
    id: StringOrNumberType.isRequired,
    name: PropTypes.string.isRequired
  })
});

export const PicklistItemType = PropTypes.shape({
  name: PropTypes.string,
  photo: PropTypes.string,
  itemId: StringOrNumberType,
  inventorySnapshot: InventorySnapshotType,
  category: PropTypes.string,
  categoryId: PropTypes.string,
  healthLevel: StringOrNumberType,
  position: PropTypes.number,
  limitRules: PropTypes.arrayOf(LimitRulesItemType)
});

export const PicklistCategoryType = PropTypes.shape({
  id: PropTypes.string,
  name: PropTypes.string,
  limitRules: PropTypes.arrayOf(LimitRulesItemType),
  position: PropTypes.number
});

export const PicklistType = PropTypes.shape({
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
  notes: PropTypes.string.isRequired,
  photo: PropTypes.string,
  trackingMethod: PropTypes.shape({
    id: PropTypes.number.isRequired,
    label: PropTypes.string.isRequired
  }),
  isVisible: PropTypes.bool.isRequired,
  limitRules: PropTypes.arrayOf(LimitRulesItemType),
  categories: PropTypes.arrayOf(PicklistCategoryType).isRequired,
  items: PropTypes.arrayOf(PicklistItemType).isRequired
});
